/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './AutoActionMailView.scss'
import React from 'react'
import { Dropdown, TextInput } from '../../atoms'
import { Edit } from '../../molecules'
import AutoLogActions from '../../../action/auto_action/AutoLogActions'
import AutoMailContentActions from '../../../action/auto_action/AutoMailContentActions'

function AutoActionMailContentEditView(props) {
  const id = props.match.params.id
  const content = props.content
  const smtp_setting_options = props.smtp_setting_options

  return (
    <Edit
      title="自動送信メールの再編集"
      buttonLabel="実行"
      onSubmit={props.id ? () => AutoLogActions.onRequestUpdate(id, content) : () => AutoLogActions.onRequestCreate(id, content)}
      onCancel={() => AutoMailContentActions.onCancel()}
    >
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <div className="textInput__label textInput__label- textInput__label-required">
              メール送信元
              <div className="textInput__optionIcon" />
            </div>
            <Dropdown name="smtp_setting_id" options={smtp_setting_options} value={content.smtp_setting_id} onChange={AutoMailContentActions.onEdit} placeholder="メール送信元" />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={content.reply_to} type="text" name="reply_to" label={'メール返信先'} placeholder="noreply@example.com" option="required" onChange={AutoMailContentActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput
              value={content.to}
              type="text"
              name="to"
              label={'メール送信先'}
              placeholder="to@example.com"
              caution="カンマで「,」区切って複数指定できます"
              onChange={AutoMailContentActions.onEdit}
            />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={content.cc} type="text" name="cc" label={'メール送信先(CC)'} caution="カンマで「,」区切って複数指定できます" onChange={AutoMailContentActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={content.bcc} type="text" name="bcc" label={'メール送信先(BCC)'} caution="カンマで「,」区切って複数指定できます" onChange={AutoMailContentActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={content.subject} type="text" name="subject" label={'件名'} placeholder="メールの件名" option="required" onChange={AutoMailContentActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__column">
        <div className="textInput__label textInput__label- textInput__label-required">
          本文
          <div className="textInput__optionIcon" />
        </div>
        <textarea className="EditArea__row--full" name="body" value={content.body || ''} rows="12" onChange={AutoMailContentActions.onEdit} />
      </div>
    </Edit>
  )
}

export default AutoActionMailContentEditView
